import BasicConfigurationElement from './BasicConfigurationElement';

// @vue/component
export default {
  name: 'ProjectBasicConfiguration',

  components: {
    BasicConfigurationElement,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/getProjectDetails',
      ]);
    },
    projectDetails() {
      return this.$store.getters['client/project/details'];
    },
  },
  methods: {
    handleEditConfigOptions(editedOption) {
      const { configItem, newValue } = editedOption;
      const params = {
        [configItem]: newValue,
      };
      this.$store.dispatch('client/project/updateProject', { ...params, project: this.projectUuid });
    },
  },
};
